import { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { ShoppingBag } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { supabase } from '../lib/supabase';

export function DashboardOrders() {
  const { t } = useLanguage();
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('orders')
      .select('id, order_number, status, payment_status, total_amount, currency, created_at')
      .order('created_at', { ascending: false })
      .limit(100)
      .then(({ data }) => {
        setOrders(data ?? []);
        setLoading(false);
      });
  }, []);

  return (
    <div className="flex flex-1 flex-col gap-6">
      <div className="rounded-3xl border border-white/10 bg-white/5 p-6 md:p-8">
        <p className="flex items-center gap-2 font-['Rubik'] text-sm font-medium text-white/60">
          <ShoppingBag className="size-4" />
          {t('business.orders')}
        </p>
        <h2 className="mt-1 font-['Sora'] text-2xl font-semibold tracking-tight text-white md:text-3xl">
          Toutes les commandes
        </h2>
        <p className="mt-1 font-['Rubik'] text-sm text-white/50">
          Historique et statut des commandes.
        </p>
      </div>

      <Card>
        <CardHeader className="border-b border-white/10">
          <CardTitle>Liste des commandes</CardTitle>
          <CardDescription>{orders.length} commande(s)</CardDescription>
        </CardHeader>
        <CardContent className="overflow-x-auto pt-6">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/20 border-t-white" />
            </div>
          ) : orders.length === 0 ? (
            <p className="py-10 text-center font-['Rubik'] text-white/50">Aucune commande.</p>
          ) : (
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="pb-3 pr-4 font-['Rubik'] text-xs uppercase tracking-wider text-white/50">
                    N°
                  </th>
                  <th className="pb-3 px-4 font-['Rubik'] text-xs uppercase tracking-wider text-white/50">
                    Date
                  </th>
                  <th className="pb-3 px-4 font-['Rubik'] text-xs uppercase tracking-wider text-white/50">
                    Statut
                  </th>
                  <th className="pb-3 px-4 font-['Rubik'] text-xs uppercase tracking-wider text-white/50">
                    Paiement
                  </th>
                  <th className="pb-3 pl-4 font-['Rubik'] text-xs uppercase tracking-wider text-white/50">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.id} className="border-b border-white/5">
                    <td className="py-4 pr-4 font-['Rubik'] text-white">
                      {o.order_number || o.id.slice(0, 8)}
                    </td>
                    <td className="py-4 px-4 font-['Rubik'] text-sm text-white/70">
                      {new Date(o.created_at).toLocaleDateString()}
                    </td>
                    <td className="py-4 px-4 font-['Rubik'] text-white/80">{o.status}</td>
                    <td className="py-4 px-4 font-['Rubik'] text-white/80">{o.payment_status}</td>
                    <td className="py-4 pl-4 font-['Sora'] text-white">
                      {Number(o.total_amount).toLocaleString()} {o.currency || 'XOF'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
